import { Link } from "react-router-dom";
import { CONTACT } from "../data/boats";
import { Instagram, Mail } from "lucide-react";

function LogoMark({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="18" cy="18" r="16.5" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="24.5" cy="10.5" r="2.4" fill="currentColor" />
      <path d="M4 17 Q8 13.5 12 17 Q16 20.5 20 17 Q24 13.5 32 17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
      <path d="M4 21.5 Q8 18 12 21.5 Q16 25 20 21.5 Q24 18 32 21.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
      <path d="M6 26 Q10 22.5 14 26 Q18 29.5 22 26 Q26 22.5 31 26" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#141412] text-white">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12 border-b border-white/8">

          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4 text-white">
              <LogoMark size={28} />
              <span className="font-serif text-xl font-light tracking-wide">Aquastays</span>
            </div>
            <p className="text-white/50 text-xs leading-relaxed font-light">
              Boutique houseboat stays on the still waters of Lough Ree, Ireland.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.instagram.com/aqua_stays"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="text-white/40 hover:text-white transition-colors"
              >
                <Instagram size={15} strokeWidth={1.5} />
              </a>
              <a
                href={`mailto:${CONTACT.email}`}
                aria-label="Email"
                className="text-white/40 hover:text-white transition-colors"
              >
                <Mail size={15} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          {/* Explore */}
          <div>
            <p className="text-[0.6rem] uppercase tracking-[0.2em] text-white/30 mb-5">Explore</p>
            <ul className="space-y-3">
              {[
                { label: "Our Houseboats", href: "/#boats" },
                { label: "The Experience", href: "/#experience" },
                { label: "Location", href: "/#location" },
              ].map(l => (
                <li key={l.href}>
                  <a href={l.href} className="text-xs text-white/55 hover:text-white transition-colors font-light">
                    {l.label}
                  </a>
                </li>
              ))}
              <li><Link to="/lough-ree-things-to-do" className="text-xs text-white/55 hover:text-white transition-colors font-light">Things to Do</Link></li>
              <li><Link to="/getting-here" className="text-xs text-white/55 hover:text-white transition-colors font-light">Getting Here</Link></li>
              <li><Link to="/faq" className="text-xs text-white/55 hover:text-white transition-colors font-light">FAQs</Link></li>
              <li><Link to="/gift-vouchers" className="text-xs text-white/55 hover:text-white transition-colors font-light">Gift Vouchers</Link></li>
            </ul>
          </div>

          {/* Boats */}
          <div>
            <p className="text-[0.6rem] uppercase tracking-[0.2em] text-white/30 mb-5">Boats</p>
            <ul className="space-y-3">
              <li>
                <a href="/boats/aquastays-drift" data-testid="footer-link-drift" className="text-xs text-white/55 hover:text-white transition-colors font-light">
                  Aquastays Drift
                </a>
              </li>
              <li>
                <a href="/boats/aquastays-lily" className="text-xs text-white/55 hover:text-white transition-colors font-light">
                  Aquastays Lily
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-[0.6rem] uppercase tracking-[0.2em] text-white/30 mb-5">Contact us</p>
            <ul className="space-y-3 text-xs text-white/55 font-light">
              <li>
                <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="hover:text-white transition-colors">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={`tel:${CONTACT.phoneIntl}`} data-testid="footer-phone" className="hover:text-white transition-colors">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="leading-relaxed">{CONTACT.location}</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-[0.6rem] text-white/30 uppercase tracking-[0.18em]">
            © {new Date().getFullYear()} Aquastays. All rights reserved.
          </p>
          <p className="text-[0.6rem] text-white/20 uppercase tracking-[0.14em]">
            Inner Lakes Marina · Lough Ree · Ireland
          </p>
        </div>
      </div>
    </footer>
  );
}
